// extracted by mini-css-extract-plugin
module.exports = {"root":"cookie-banner-module--root--IDYTf","visible":"cookie-banner-module--visible--58Gzx"};